// @flow

import type { FlatError } from '../../../helpers/flattenError';

import type { State } from '../state';

type GlobalState = {
  settings: State,
};

const getReducer = (state: GlobalState) => state.settings;

export const isFetching = (state: GlobalState): boolean => (
  !!getReducer(state).fetching
);

export const isFetched = (state: GlobalState): boolean => (
  !!getReducer(state).fetched
);

export const hasError = (state: GlobalState): boolean => (
  !!getReducer(state).error
);

export const getError = (state: GlobalState): ?FlatError => (
  getReducer(state).error
);

export const needsLoading = (state: GlobalState): boolean => (
  !isFetching(state) && !hasError(state) && !isFetched(state)
);
